import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useMutation } from "src/Hooks/useReactQuery";
import { editInstance } from "src/services/project-instances";
import APP_ROUTES from "src/routes/routes";

const useEditInstanceDetail = (getRedirectURL = () => APP_ROUTES.SEQUENCES) => {
  const { t } = useTranslation("project-instance");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);

  const editInstanceMutation = useMutation({
    mutationFn: ({ data, id }) => editInstance({ data, id }),
  });

  const submitData = ({ data, id }, callback) => {
    editInstanceMutation.mutate(
      { data, id },
      {
        onSuccess: () => {
          showAlert({
            status: true,
            message: t("detail.edit_success"),
            type: "success",
          });
          navigate(getRedirectURL());
        },
        onError: () => {
          const isSubmitFailed = true;
          callback?.(isSubmitFailed);
        },
        onSettled: () => {
          const isSubmitFailed = false;
          callback?.(isSubmitFailed);
        },
      }
    );
  };

  return {
    editInstanceMutation,
    submitData,
    isLoading: editInstanceMutation.isLoading,
    isError: editInstanceMutation.isError,
    error: editInstanceMutation.error,
  };
};

export default useEditInstanceDetail;
